/* eslint-disable react/prop-types */
import {
  FilterList as FilterIcon,
  KeyboardArrowDown as ArrowDownIcon,
} from "@mui/icons-material";
import { Box, Button, Menu, MenuItem, Chip, Badge } from "@mui/material";
import { useState } from "react";

interface PracticeUserFiltersProps {
  role: string;
  status: string;
  onRoleChange: (role: string) => void;
  onStatusChange: (status: string) => void;
}

const ROLES = [
  { value: "", label: "All Roles" },
  { value: "patient", label: "Patient" },
  { value: "provider", label: "Provider" },
  { value: "staff", label: "Staff" },
  { value: "admin", label: "Admin" },
];

const STATUSES = [
  { value: "", label: "All Status" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const PracticeUserFilters: React.FC<PracticeUserFiltersProps> = ({
  role,
  status,
  onRoleChange,
  onStatusChange,
}) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const activeFiltersCount = [role, status].filter(Boolean).length;

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleRoleSelect = (selectedRole: string) => {
    onRoleChange(selectedRole);
  };

  const handleStatusSelect = (selectedStatus: string) => {
    onStatusChange(selectedStatus);
  };

  const clearFilters = () => {
    onRoleChange("");
    onStatusChange("");
  };

  return (
    <Box className="flex items-center gap-2">
      <Badge
        color="primary"
        badgeContent={activeFiltersCount}
        invisible={activeFiltersCount === 0}
      >
        <Button
          variant="outlined"
          startIcon={<FilterIcon />}
          endIcon={<ArrowDownIcon />}
          onClick={handleMenuOpen}
          sx={{
            borderColor: "#E5E7EB",
            color: "#374151",
            "&:hover": {
              borderColor: "#D1D5DB",
              backgroundColor: "#F9FAFB",
            },
          }}
        >
          Filter
        </Button>
      </Badge>

      {activeFiltersCount > 0 && (
        <Chip
          label={`${activeFiltersCount} filter${activeFiltersCount > 1 ? "s" : ""}`}
          size="small"
          onDelete={clearFilters}
          sx={{
            backgroundColor: "#3B82F6",
            color: "white",
            "& .MuiChip-deleteIcon": {
              color: "white",
            },
          }}
        />
      )}

      {/* Unified Filter Menu */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem disabled dense>
          Role
        </MenuItem>
        {ROLES.map((roleOption) => (
          <MenuItem
            key={roleOption.value}
            onClick={() => handleRoleSelect(roleOption.value)}
            selected={role === roleOption.value}
          >
            {roleOption.label}
          </MenuItem>
        ))}
        <MenuItem disabled dense>
          —
        </MenuItem>
        <MenuItem disabled dense>
          Status
        </MenuItem>
        {STATUSES.map((statusOption) => (
          <MenuItem
            key={statusOption.value}
            onClick={() => handleStatusSelect(statusOption.value)}
            selected={status === statusOption.value}
          >
            {statusOption.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default PracticeUserFilters;
